import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import PropTypes from 'prop-types';
import i18next from 'i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { getUser } from 'redux/actions/userActions';
import { getConfig } from 'redux/actions/configActions';
import 'bootstrap/dist/css/bootstrap.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, ThemeProvider } from '@material-ui/core/styles';
import { StylesProvider } from '@material-ui/styles';
import { AbilityContext, ability } from 'utils/permissions';
import { CAN_SEE_COVERAGE } from 'constants/misc';
import './styles/app.scss';
// eslint-disable-next-line no-unused-vars
import styles from './output.css';
import GlobalStylesWrapper from './GlobalStylesWrapper';
import ScrollToTop from './components/ScrollToTop';
import { config as i18nextConfig } from './translations';
import LightTheme from '../src/themes/light-theme';
import { updateAbilityWithPerm } from './utils/permissions';

i18next.init(i18nextConfig);

window.analytics.load(process.env.SEGMENT_PUBLIC_API_KEY);
window.analytics.page();

class App extends Component {
  componentDidMount() {
    this.props.getUser();
    this.props.getConfig();
  }

  render() {
    const { loading, loaded, isAuthenticated } = this.props.user;
    const { loading: configLoading, loaded: configLoaded, canSeeCoverage } = this.props.config;
    const childProps = {
      loading: loading || configLoading,
      loaded: loaded && configLoaded,
      isAuthenticated,
      canSeeCoverage,
    };
    if (this.props.config.canSeeCoverage) {
      updateAbilityWithPerm(ability, CAN_SEE_COVERAGE);
    }
    return (
      <AbilityContext.Provider value={ability}>
        <StylesProvider injectFirst>
          <CssBaseline />
          <ThemeProvider theme={LightTheme}>
            <MuiThemeProvider theme={LightTheme}>
              <BrowserRouter>
                <I18nextProvider i18n={i18next}>
                  <ScrollToTop>
                    <GlobalStylesWrapper {...childProps} />
                  </ScrollToTop>
                </I18nextProvider>
              </BrowserRouter>
            </MuiThemeProvider>
          </ThemeProvider>
        </StylesProvider>
      </AbilityContext.Provider>
    );
  }
}

App.defaultProps = {
  user: {},
  config: {},
};

App.propTypes = {
  getUser: PropTypes.func.isRequired,
  getConfig: PropTypes.func.isRequired,
  config: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    emailBackend: PropTypes.bool.isRequired,
  }),
  user: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
  }),
};

export default hot(connect(
  state => ({
    user: state.user,
    config: state.config,
  }),
  { getUser, getConfig },
)(App));
